export default __webpack_public_path__ + "assets/images/8f31e7d70a31b8936cda758f69ffdffb.png";